import { BsaOrderPlaceholderXBVO } from "./dto.models.imported";

/**
 * Model - OrderWeekModel
 */
export class OrderWeekModel {
    year: Number;
    week: Number;
    daysModel: Array<OrderDayModel> = [];
}

/**
 * Model = OrderPlaceholderDayModel
 */
export class OrderDayModel {
    year: Number;
    week: Number;
    serviceDay: Date;
    dayMessage: String;
    placeholders: Array<BsaOrderPlaceholderXBVO> = [];

    constructor() {
    }

    /**
     * Creates.
     * @param aDay
     */
    public static create(aDay: Date, aPlaceholders: BsaOrderPlaceholderXBVO[]) {
        let pResult = new OrderDayModel();
        pResult.serviceDay = aDay;
        pResult.placeholders = aPlaceholders;
        return pResult;
    }
}

export class OneTimeNotificationDto {
    prio: boolean;
    messageId: string;
    messageParams: string[] = [];
    alertType: EnumNotificationType;
}

export enum EnumNotificationType {
    INFO = 'INFO',
    WARN = 'WARN',
    ALERT = 'ALERT',
    MENUPLAN_CHANGED = 'MENUPLAN_CHANGED'
}
